import React from 'react';
import Logo from '../../General/Logo/Logo';
import LanguageControl from './Components/LanguageControl';
import HelpControl from './Components/HelpControl';
import UserControl from '../../General/UserControl/UserControl';
import HeaderMenu from './HeaderMenu';
import styles from './Header.module.scss';
import i18next from 'i18next';
import { useSelector } from 'react-redux';
import {
    eplassSliceDocumentName,
    eplassSliceDocumentVersion,
    eplassSliceDocumentSubject,
} from '../../../Redux/EplassSlice';
import { Box, Stack, Tooltip } from '@mui/material';

export default () => {
    // ToDO: /** Access to DefaultBreakpointContext */
    // const {
    //     breakpoints: { tablet },
    // } = useContext(DefaultBreakpointsContext);

    /** Get relevant values from Redux store. */
    const documentNumber = useSelector(eplassSliceDocumentName);
    const documentIndex = useSelector(eplassSliceDocumentVersion);
    const documentSubject = useSelector(eplassSliceDocumentSubject);

    let documentTitle: string = documentSubject;

    if (documentNumber) {
        const docIndex = `${documentIndex?.trim() ? ' - ' + documentIndex : ''}`;

        documentTitle = `${documentNumber}${docIndex}`;
    }

    const toolTipTitle = `${i18next.t('header.document')}: ${documentTitle}`;

    return (
        <Box className={styles.header}>
            <Logo />
            <Box>
                <HeaderMenu isTablet={false /* ToDO: tablet.isAtMost */} />
            </Box>
            <Tooltip title={toolTipTitle}>
                <Box className={styles.main}>{documentTitle}</Box>
            </Tooltip>
            <Stack direction="row" className={styles.controls}>
                <HelpControl />
                <LanguageControl />
                <UserControl />
            </Stack>
        </Box>
    );
};
